import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import {withStyles} from '@material-ui/core/styles';
import {Redirect, Link} from 'react-router-dom'
import Utility from "../../Utility";

const styles = theme => ({
    root: {
        textAlign: 'center'
    },
    form: {
        margin: 'auto',
        width: '80%',
    },
    button: {
        margin: 'auto',
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit,
        width: '80%',
    }
});

function createLinkButton(pathname, label, search, disabled){
    let ButtonLink;
    if(search != null){
        ButtonLink = props => <Link to={{pathname: pathname, search: search}} {...props} />;
    }
    else{
        ButtonLink = props => <Link to={{pathname: pathname}} {...props} />;
    }
    return (
        <Button component={ButtonLink} variant="contained" color="primary" fullWidth disabled={disabled}>{label}</Button>
    )
}

export class SelectDeliveryPeriod extends React.Component {
    constructor(props){
        super(props);

        let params = new URLSearchParams(this.props.location.search);
        this.pompSpecId = params.get("pompSpecId");

        this.state = {
            deliveryStart: Utility.formatDate(Utility.getTomorrowDate(), 'yyyy-MM-dd'),
            deliveryEnd: Utility.formatDate(Utility.getTomorrowDate(), 'yyyy-MM-dd'),
        };

        this.onChangeDeliveryStart = this.onChangeDeliveryStart.bind(this);
        this.onChangeDeliveryEnd = this.onChangeDeliveryEnd.bind(this);
        this.isDisabled = this.isDisabled.bind(this);

        if(this.props.onScreen !== undefined){
            this.props.onScreen('配車期間入力画面');
        }
    }

    onChangeDeliveryStart(event){
        this.setState({deliveryStart: event.target.value});
    }

    onChangeDeliveryEnd(event){
        this.setState({deliveryEnd: event.target.value});
    }

    isDisabled(){
        // 日付形式でない場合はNG.
        if(!Utility.isDate(this.state.deliveryStart) || !Utility.isDate(this.state.deliveryEnd)){
            return true;
        }
        // 配車開始日が配車終了日より前日でない場合はNG.
        else if(!Utility.isDateAEqualOrBeforeB(this.state.deliveryStart, this.state.deliveryEnd)){
            return true;
        }
        // 最長配車期間を超えている場合はNG.
        else if(Utility.isOverMaxDeliveryPeriod(this.state.deliveryStart, this.state.deliveryEnd)){
            return true
        }
        else{
            return false;
        }
    }

    render(){
        // KECアカウントでない場合はアクセス不可のためトップ画面へリダイレクト.
        if(!Utility.isKecRole(this.props.cookies.get('role'))){
            return <Redirect to={{pathname: '/'}}/>;
        }

        // クエリパラメータが不正であればトップ画面へリダイレクト.
        if(this.pompSpecId === '' || this.pompSpecId === null){
            return <Redirect to={{pathname: "/",}}/>;
        }

        return (
            <div className={this.props.classes.root}>
                <div className={this.props.classes.form}>
                    <div>
                        <TextField
                            label="配車開始日(yyyy-MM-dd)"
                            type="date"
                            margin="normal"
                            variant="outlined"
                            defaultValue={this.state.deliveryStart}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={this.onChangeDeliveryStart}
                            fullWidth
                        />
                    </div>
                    <div>
                        <TextField
                            label="配車終了日(yyyy-MM-dd)"
                            type="date"
                            margin="normal"
                            variant="outlined"
                            defaultValue={this.state.deliveryEnd}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            onChange={this.onChangeDeliveryEnd}
                            fullWidth
                        />
                    </div>
                    <div>
                        {createLinkButton(this.props.nextPath, '決定', '?pompSpecId=' + this.pompSpecId + '&deliveryStart=' + this.state.deliveryStart + '&deliveryEnd=' + this.state.deliveryEnd, this.isDisabled())}
                    </div>
                </div>
                <div className={this.props.classes.button}>
                    {createLinkButton(this.props.backPath, "ポンプ仕様選択画面へ戻る", null, false)}
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(SelectDeliveryPeriod);
